import './css/site.scss';
import main from './main';

const renderApp = async () => {
    await main();
};


renderApp();
